import config from '../../common/config';

const state = {
  rideCenter: { lat: 45.508, lng: 40.587 },
  rideMarkers: [],
  places: [],
  rideCurrentPlace: null,
  rideAppMap: null,
  ridePresentedDay: null,
  rideFocusDay: 0,

};
const getters = {
  rideCenter: state => state.rideCenter,
  rideMarkers: state => state.rideMarkers,
  places: state => state.places,
  rideCurrentPlace: state => state.rideCurrentPlace,
  rideAppMap: state => state.rideAppMap,
  ridePresentedDay: state => state.ridePresentedDay,
  rideFocusDay: state => state.rideFocusDay,
};
const actions = {
  rideAddMarkerByLatAndLng: ({dispatch, getters }, point) => {
    const rideAppMap = getters.rideAppMap;
    const rideMarkers = getters.rideMarkers;
    if( rideAppMap ){
      dispatch( 'addMarkerByLatAndLng', { 
        map:rideAppMap,
        rideMarkers: rideMarkers,
        point:point
       });
      }
  },
  AddAccommodationMarkerByIndex: ({ dispatch, getters }, accommodationParameters ) => {
    const daylyAttraction = getters.allRide.attractionsByDay[ accommodationParameters.dayIndex ];
    var evningAccommodation = null
    if ( Object.keys( daylyAttraction.accommodation ).length ){
      evningAccommodation = daylyAttraction.accommodation
    }
    else if ( Object.keys( daylyAttraction.base_trip_accommodation ).length ){
      evningAccommodation = daylyAttraction.base_trip_accommodation
    }
    if ( evningAccommodation ){
      var lat = parseFloat( evningAccommodation.latitude);
      var lng = parseFloat( evningAccommodation.longtitude);
      if (lat && lng ){
        dispatch( 'rideAddMarkerByLatAndLng', { latPoint: lat,
                                                lngPoint: lng,
                                                name:accommodationParameters.name,
                                                iconUrl: accommodationParameters.iconUrl });
      }
    }  
  },
  async rideUpdateMarkerOfDay({ dispatch, getters}, dayIndex ){
    const daylyAttraction = getters.allRide.attractionsByDay[dayIndex];
    var i;
    if( ! daylyAttraction ){return;}
    const baseCircleUrl = config.config.BLUE_MAP_POINT_CIRCLE_BASE;
    //all the attraction at the day
    for(i=0; i < daylyAttraction.daily_attractions.length; i++ ){
      var lat = parseFloat(daylyAttraction.daily_attractions[i].latitude);
      var lng = parseFloat(daylyAttraction.daily_attractions[i].longtitude);
      var point = { latPoint: lat, lngPoint: lng, name: daylyAttraction.daily_attractions[i].title };
      if( daylyAttraction.daily_attractions[i].iconUrl )
        point.iconUrl = daylyAttraction.daily_attractions[i].iconUrl;
      else
        point.numberedMarker = { baseCircleUrl, number: i + 1 };
      dispatch( 'rideAddMarkerByLatAndLng', point);
    }
    const shouldPresentingTheAccommodationOfDayBefor = await dispatch( 'shouldPresentTheHoteOFTheDayBefor', dayIndex );
    const accommodationIconAtNight = await dispatch( 'accommodationIcon', dayIndex );
    dispatch( 'AddAccommodationMarkerByIndex', {  dayIndex: dayIndex,
                                                  iconUrl: accommodationIconAtNight});
    if( shouldPresentingTheAccommodationOfDayBefor ){
      dispatch( 'AddAccommodationMarkerByIndex', {  dayIndex: dayIndex-1,
                                                    iconUrl: config.config.MAP_POINT_ACCOMMODATION_CHECKOUT});
    }
  },
  rideRemoveAllMarkers: ({dispatch, getters}) =>{
    dispatch( 'removeAllMarkers', getters.rideMarkers );

  },
  async accommodationIcon({ getters}, dayIndex){
    const accommodationIconsByDays = getters.accommodationIconsByDays;
    return accommodationIconsByDays[dayIndex]
  },
  async shouldPresentTheHoteOFTheDayBefor({getters}, dayIndex){
    if( dayIndex == 0 )
      return false;
    const daylyAttraction = getters.allRide.attractionsByDay[dayIndex];
    if( Object.keys( daylyAttraction.accommodation ).length )
      return daylyAttraction.accommodation.firestDayAtThisAccommodation
    if( Object.keys( daylyAttraction.base_trip_accommodation ).length )
      return daylyAttraction.base_trip_accommodation.firestDayAtThisAccommodation
    return true
  },
  async rideUpdateMarkerByDayIndex({dispatch ,commit },dayIndex){
    var dayToUpdate = await dispatch( 'rideGetTheFocuesDay' );// work around to wait for the map to be load ( probably )
    dayToUpdate = dayIndex
    await dispatch('rideRemoveAllMarkers');// work around to wait for the map to be load ( probably )
    commit( 'rideSetPresentedDay', dayToUpdate );
    await dispatch( 'rideUpdateMarkerOfDay', dayToUpdate );
    dispatch( 'rideFitBoundesToMarkers');
  },
  async rideUpdateMarkerByScrollerLocation({dispatch , commit, getters }, forceUpadate = false){
    const isItMobile = getters.isMobile;
    var dayToUpdate = await dispatch( 'rideGetTheFocuesDay' );
    const ridePresentedDay = await getters.ridePresentedDay;
    if ( ( ridePresentedDay == dayToUpdate ) && ( forceUpadate != true ) )return;
    commit( 'rideSetPresentedDay', dayToUpdate );
    
    if ( ( isItMobile ) && ( forceUpadate != true ) ){
      return;
    }
    await dispatch('rideRemoveAllMarkers');
    // TODO we should remove this and help the application to load the map at the first day upload after refresh
    if( ! getters.allRide.attractionsByDay ){return;}
    await dispatch( 'rideUpdateMarkerOfDay', dayToUpdate );
    dispatch( 'rideFitBoundesToMarkers');
    
  },
  async rideGetTheFocuesDay({getters, commit }){
    const daylyAttraction = await getters.allRide.attractionsByDay;
    if( ! daylyAttraction ){return 1000;}// in order to update at the first time that the map is lowded
    var i;
    var rect;
    for(i=0; i < daylyAttraction.length; i++ ){
      const dailyAttractionItem = document.getElementById('daily_attraction_day_' + i );
      if( ! dailyAttractionItem ){
        commit( 'rideSetRideFocusDay', 0 )  
        return 0;
      }
      rect = dailyAttractionItem.getBoundingClientRect()
      if ( rect.y > 210 ){// this is the topest item at the page
        if ( i == 0 ){
          commit( 'rideSetRideFocusDay', 0 )
          return 0;
        }
        commit( 'rideSetRideFocusDay', i )
        return i-1;
      }
    }
    // when the one befor the last one is going out
    if (rect.y + rect.height > 210) {
      // Element has scrolled completely out of view (above the viewport)
      commit( 'rideSetRideFocusDay', daylyAttraction.length )
    }
    else{
      commit( 'rideSetRideFocusDay', 0 )
    }
    return daylyAttraction.length - 1;
  },

  rideFitBoundesToMarkers: ({getters, dispatch}) => {
    const rideAppMap = getters.rideAppMap;
    const rideMarkers = getters.rideMarkers;
    if( rideAppMap ){
      dispatch( 'fitBoundesToMarkers', { 
       appMap:rideAppMap,
       markers: rideMarkers
       });
      }
    },
  rideAddMarker: ({state, commit }) => {
    if (state.rideCurrentPlace) {
      const marker = {
        lat: state.rideCurrentPlace.geometry.location.lat(),
        lng: state.rideCurrentPlace.geometry.location.lng()
      };
      commit( 'rideAddMarker', marker );
      commit( 'addRidePlace', state.rideCurrentPlace );
      commit( 'setrideCenter', marker);
      commit( 'ridesetCurrentPlace', null);
    }
  },
}
const mutations = {
  ridesetCurrentPlace( state, place ) {
    state.rideCurrentPlace = place;
  },
  rideSetAppMap( state, rideAppMap ) {
    state.rideAppMap = rideAppMap;
    // const forceMapUpdate = true;
    // this.dispatch( 'rideUpdateMarkerByScrollerLocation', forceMapUpdate );
  },
  rideAddMarker( state, marker ) {
    state.rideMarkers.push( marker );
  },
  cleanRideMarkers( state ) {
    state.rideMarkers = [];
  },
  addRidePlace( state, place ) {
    state.places.push( { place } );
  },
  setrideCenter( state, rideCenter ) {
    state.rideCenter =  rideCenter;
  },
  rideSetPresentedDay( state, dayNumber ) {
    state.ridePresentedDay = dayNumber;
  },
  rideSetPresentedDayIndex( state, map ){
    state.rideListMaps.push( map );
  },
  rideSetRideFocusDay( state, rideFocusDay ){
    state.rideFocusDay =  rideFocusDay;
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};
